import { FC, ReactNode, useEffect, useState } from 'react';
import { KalenderhändelsearkivResponse } from '../../types/pages';
import styles from './KompaktKalender.module.css';
import { Heading, BodyText } from '@kpa/kul';
import { useNavigate } from 'react-router-dom';
import KalenderHändelse from './KalenderHändelse';
import { konverteraKalenderHändelserTillYearMap, YearMap } from './konverteraDatumTillMap';

type KompaktKalenderProps = {
  response: KalenderhändelsearkivResponse;
};

const KompaktKalender: FC<KompaktKalenderProps> = ({ response }): ReactNode => {
  const [yearMap, setYearMap] = useState<YearMap>();
  const nav = useNavigate();

  useEffect(() => {
    const yearMap = konverteraKalenderHändelserTillYearMap(response.kalenderhändelser);
    setYearMap(yearMap);
  }, [response]);

  const redirect = (e: React.MouseEvent<HTMLAnchorElement | MouseEvent>, url: string) => {
    e.preventDefault();
    nav(url);
  };

  return (
    <div className={styles.container}>
      {response.rubrik && <Heading headingLevel={2} className={styles.header}>{response.rubrik}</Heading>}
      <ul className={styles.ul}>
        {yearMap !== undefined && Array.from(yearMap.values())
          .map(year => Array.from(year.values())
            .map(month => Array.from(month.values())
              .map(händelser =>
                händelser.map(händelse => (
                  <li className={styles.li} key={händelse.id}>
                    <KalenderHändelse händelse={händelse}></KalenderHändelse>
                  </li>
                )),
              )),
          )}
      </ul>
      {
        ('url' in response && response.url) && (
          <a href={response.url} className={styles.footer} onClick={e => redirect(e, response.url ?? '')} rel="noopener noreferrer">
            <BodyText color="darkBlue">Alla kalenderhändelser</BodyText>
          </a>
        )
      }
    </div>
  );
};

export default KompaktKalender;
